import React from 'react';
import { Modal } from 'bloomer/lib/components/Modal/Modal';
import { ModalBackground } from 'bloomer/lib/components/Modal/ModalBackground';
import { ModalCard } from 'bloomer/lib/components/Modal/Card/ModalCard';
import { ModalCardHeader } from 'bloomer/lib/components/Modal/Card/ModalCardHeader';
import { ModalCardTitle } from 'bloomer/lib/components/Modal/Card/ModalCardTitle';
import { Delete } from 'bloomer/lib/elements/Delete';
import { ModalCardBody } from 'bloomer/lib/components/Modal/Card/ModalCardBody';
import { ModalCardFooter } from 'bloomer/lib/components/Modal/Card/ModalCardFooter';
import { Button } from 'bloomer/lib/elements/Button';
import { PatioRuleContextConsumer } from '../DataProviders/PatioRules';
import { Content } from 'bloomer/lib/elements/Content';

interface PropTypes {
  isOpen: boolean;
  closeModal: () => void;
}

const PatioInfoModal = ({ isOpen, closeModal }: PropTypes) => (
  <Modal isActive={isOpen}>
    <ModalBackground />
    <ModalCard>
      <ModalCardHeader>
        <ModalCardTitle>Patio Rules and Notices:</ModalCardTitle>
        <Delete onClick={closeModal} aria-label="close" />
      </ModalCardHeader>

      <ModalCardBody>
        <PatioRuleContextConsumer>
          {({ patioRules }: { patioRules: string | null }) => (
            <Content
              dangerouslySetInnerHTML={{ __html: patioRules || 'No Rules have been posted yet. Check back later.' }}
            ></Content>
          )}
        </PatioRuleContextConsumer>
      </ModalCardBody>
      <ModalCardFooter>
        <Button onClick={closeModal}>Close</Button>
      </ModalCardFooter>
    </ModalCard>
  </Modal>
);

export default PatioInfoModal;
